import { toLower } from 'ramda';

const roleIdentifierComparator = roleIdentifier => `${toLower(roleIdentifier.name)}-${toLower(roleIdentifier.team)}`;

export default roleIdentifierComparator;
